// extracted by mini-css-extract-plugin
export default {"wrapper":"FileViewer_wrapper__nWN7x"};